import React, { useState, useMemo, useEffect, useCallback } from "react";
import { Drawer } from "antd";
import Group from "@/components/Joyspace/pages/Group";
import { connect } from "dvajs";
import { withTranslation } from "react-i18next";
import events from "@/components/Joyspace/context/events";
import GroupSearch from "../GroupSearch";
import "./index.less";
import { ErrorCode } from "@/components/Joyspace/types";
import ErrorPage from "@/components/Joyspace/pages/Group/ErrorPage";

function GroupSpaceDrawer() {
  const [visible, setVisible] = useState<boolean>(false);
  const [groupInfo, setGroupInfo] = useState<any>(null);
  const [errCode, setErrCode] = useState<string>("");

  const changePrentVisible = useCallback((params) => {
    setVisible(params.visible);
    console.log(params, "groupInfogroupInfogroupInfogroupInfo");
    setGroupInfo(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    events.on("joyspace.groupSpace", changePrentVisible);
    events.on("groupSpace:setErrCode", setErrCode);
    return () => {
      events.removeListener("joyspace.groupSpace", changePrentVisible);
      events.removeListener("groupSpace:setErrCode", setErrCode);
    };
  }, [changePrentVisible]);
  const groupMain = useMemo(() => {
    console.log(groupInfo, "groupMain====>");
    if (!groupInfo) {
      return null;
    }
    if (errCode === ErrorCode.Delete || errCode === ErrorCode.noPermission) {
      return <ErrorPage errCode={errCode} />;
    }
    return <Group {...groupInfo} />;
  }, [groupInfo, errCode]);
  return (
    <Drawer
      closable
      destroyOnClose
      width="676"
      visible={visible}
      className="groupspace_body"
      onClose={() => {
        events.emit("joyspace.groupSpace:close");
        setGroupInfo(null);
        setErrCode("");
        setVisible(false);
      }}
      title={
        <div className="portal-header">
          <div className="groupspace-head-title">群空间</div>
          <GroupSearch {...groupInfo} />
        </div>
      }
    >
      {groupMain}
    </Drawer>
  );
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps() {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation("joyspace")(GroupSpaceDrawer));
